module.exports = __webpack_public_path__ + "img/dark-street-silhouette.83297b84.jpg";